import { render, staticRenderFns } from "./vendorNewEdit.vue?vue&type=template&id=6dae452d&"
import script from "./vendorNewEdit.vue?vue&type=script&lang=js&"
export * from "./vendorNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports